import "core-js/modules/es.number.constructor.js";
export default {
  name: "StaticSpinner",
  props: {
    thickness: {
      type: Number,
      "default": 9
    },
    color: {
      type: String,
      "default": "tw-stroke-white"
    }
  }
};